import React from "react";

function Introduction() {
  return (
    <div className="space-y-16">
      <div className="space-y-7">
        <p className="text-2xl text-green-600 font-bold">Hi, my name is</p>
        <p className="text-8xl text-green-500 font-bold">Harry Duong.</p>
        <p className="text-5xl text-stone-300">
          I'm a Third-year student at Northeastern University.
        </p>
        <p className="text-2xl text-stone-400 w-1/2">
          I aspire to be a software engineer, making the most out of my
          knowledge in both technology and finance to build solutions that
          provide delightful and impactful experiences.
        </p>
      </div>
    </div>
  );
}

export default Introduction;
